import React from 'react'
import { connect, Field, FieldArray, FastField } from 'formik'
import { makeStyles, Button, Grid, FieldGroup, FormikInputField } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import { FormikHtmlEditor, FormikUploadImage } from '@paintscout/ui-business'
import type {
  PresentationSectionFormProps,
  FormikPresentationSectionConnectProps,
  FormikPresentationSectionValues
} from '../../'
import { MoveRemoveButtons } from '../../util'

const useStyles = makeStyles((theme: Theme) => ({
  documentRow: {
    paddingBottom: theme.spacing(3)
  }
}))

const DocumentsForm = ({ formik, ...props }: PresentationSectionFormProps & FormikPresentationSectionConnectProps) => {
  const classes = useStyles(props)
  const { section } = formik.values

  return (
    <>
      <Grid container spacing={3}>
        <Grid item md={12}>
          <Field component={FormikInputField} fullWidth={true} name="section.title" label={'Title'} />
        </Grid>

        <Grid item md={12}>
          <FieldGroup label={'Documents'}>
            <FieldArray
              name="section.fields.rows"
              render={(arrayHelpers) => (
                <Grid container spacing={3}>
                  {(section?.fields?.rows ?? []).map((row, index) => (
                    <Grid item md={12} key={index}>
                      <DocumentsRow section={section} index={index} arrayHelpers={arrayHelpers} classes={classes} />
                    </Grid>
                  ))}

                  <Grid item md={12}>
                    <Button
                      onClick={() => {
                        arrayHelpers.push({ image: null, title: '', content: '' })
                      }}
                      variant={'outlined'}
                      fullWidth={true}
                    >
                      Add Document
                    </Button>
                  </Grid>
                </Grid>
              )}
            />
          </FieldGroup>
        </Grid>
      </Grid>
    </>
  )
}

interface DocumentsRowProps {
  index: number
  section: any
  arrayHelpers: any
  classes: ReturnType<typeof useStyles>
}

function DocumentsRow({ index, section, arrayHelpers, classes }: DocumentsRowProps) {
  return (
    <Grid container spacing={3} alignItems={'flex-start'} className={classes.documentRow}>
      <Grid item xs={12} md={3}>
        <Field
          component={FormikUploadImage}
          label={'PDF'}
          name={`section.fields.rows.${index}.image`}
          maxWidth={360}
          maxHeight={360}
          buttonHeight={100}
          quality={1}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <Grid container spacing={3} alignItems={'flex-start'}>
          <Grid item xs={12} md={5}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Field
                  component={FormikInputField}
                  label={'Title'}
                  name={`section.fields.rows.${index}.title`}
                  fullWidth={true}
                />
              </Grid>
              {section?.fields?.rows.length > 1 && (
                <Grid item xs={12}>
                  <MoveRemoveButtons arrayHelpers={arrayHelpers} index={index} section={section} horizontal={true} />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} md={7}>
            <FastField
              component={FormikHtmlEditor}
              label={'Description'}
              name={`section.fields.rows.${index}.content`}
              fullWidth={true}
              debounce={true}
              toolbar={{
                headings: true,
                align: true
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default connect<PresentationSectionFormProps, FormikPresentationSectionValues>(DocumentsForm)
